// Generated file : do not modify

import * as signalR from '@microsoft/signalr';
import { storeSession } from '@/generated/stores';
import { ListItem } from '@/extend/classes/ListData';
import Etablissement from '@/extend/classes/Etablissement';
import Synchro98 from '@/extend/classes/Synchro98';
import Route from '@/extend/classes/Route';
import ChatItem from '@/extend/classes/ChatItem';
import Dialog from '@/extend/classes/Dialog';
import { DialogActionData } from '@/generated/classes/Dialog';
import Cart from '@/extend/classes/Cart';
import { PayboxData } from '@/generated/classes/Carte';
import GraphData from '@/extend/classes/GraphData';
import MetaAttrib from '@/extend/classes/MetaAttrib';
import { WidgetData } from '@/generated/classes/DashboardWidget';

export interface ContratSignContrat {
  (value: string): void;
}

export interface EtablissementFractionUpdated {
  (value: Etablissement): void;
}

export interface Synchro98Progress {
  (value: Synchro98): void;
}

export interface RouteShowRoute {
  (value: Route): void;
}

export interface FilesProgress {
  (value: string): void;
}

export interface ChatItemCreated {
  (value: ChatItem): void;
}

export interface DialogQuestion {
  (value: Dialog): void;
}

export interface DialogAction {
  (value: DialogActionData): void;
}

export interface DialogRefresh {
  (value: Dialog): void;
}

export interface CartUpdated {
  (value: Cart): void;
}

export interface CartTagUpdated {
  (value: Cart): void;
}

export interface TransactionRapproched {
  (value: boolean): void;
}

export interface CarteLoadPaybox {
  (value: PayboxData): void;
}

export interface GraphDataAdditional {
  (value: GraphData): void;
}

export interface MetaAttribDefine {
  (value: MetaAttrib): void;
}

export interface DashboardWidgetUpdated {
  (value: WidgetData): void;
}

export interface AccidentTravailCreated {
  (value: ListItem): void;
}

export interface AccidentTravailUpdated {
  (value: ListItem): void;
}

export interface AccidentTravailDeleted {
  (value: ListItem): void;
}

export interface AccountEntryCreated {
  (value: ListItem): void;
}

export interface AccountEntryUpdated {
  (value: ListItem): void;
}

export interface AccountEntryDeleted {
  (value: ListItem): void;
}

export interface ActiviteCreated {
  (value: ListItem): void;
}

export interface ActiviteUpdated {
  (value: ListItem): void;
}

export interface ActiviteDeleted {
  (value: ListItem): void;
}

export interface ActualiteCreated {
  (value: ListItem): void;
}

export interface ActualiteUpdated {
  (value: ListItem): void;
}

export interface ActualiteDeleted {
  (value: ListItem): void;
}

export interface AdresseCreated {
  (value: ListItem): void;
}

export interface AdresseUpdated {
  (value: ListItem): void;
}

export interface AdresseDeleted {
  (value: ListItem): void;
}

export interface ApprentiCreated {
  (value: ListItem): void;
}

export interface ApprentiUpdated {
  (value: ListItem): void;
}

export interface ApprentiDeleted {
  (value: ListItem): void;
}

export interface AttestationCreated {
  (value: ListItem): void;
}

export interface AttestationUpdated {
  (value: ListItem): void;
}

export interface AttestationDeleted {
  (value: ListItem): void;
}

export interface AttestationDefCreated {
  (value: ListItem): void;
}

export interface AttestationDefUpdated {
  (value: ListItem): void;
}

export interface AttestationDefDeleted {
  (value: ListItem): void;
}

export interface AuthorizedCreditCreated {
  (value: ListItem): void;
}

export interface AuthorizedCreditUpdated {
  (value: ListItem): void;
}

export interface AuthorizedCreditDeleted {
  (value: ListItem): void;
}

export interface BankCreated {
  (value: ListItem): void;
}

export interface BankUpdated {
  (value: ListItem): void;
}

export interface BankDeleted {
  (value: ListItem): void;
}

export interface BillCreated {
  (value: ListItem): void;
}

export interface BillUpdated {
  (value: ListItem): void;
}

export interface BillDeleted {
  (value: ListItem): void;
}

export interface ChatCreated {
  (value: ListItem): void;
}

export interface ChatUpdated {
  (value: ListItem): void;
}

export interface ChatDeleted {
  (value: ListItem): void;
}

export interface CiviliteCreated {
  (value: ListItem): void;
}

export interface CiviliteUpdated {
  (value: ListItem): void;
}

export interface CiviliteDeleted {
  (value: ListItem): void;
}

export interface ClientCreated {
  (value: ListItem): void;
}

export interface ClientUpdated {
  (value: ListItem): void;
}

export interface ClientDeleted {
  (value: ListItem): void;
}

export interface ContactCreated {
  (value: ListItem): void;
}

export interface ContactUpdated {
  (value: ListItem): void;
}

export interface ContactDeleted {
  (value: ListItem): void;
}

export interface ContratCreated {
  (value: ListItem): void;
}

export interface ContratUpdated {
  (value: ListItem): void;
}

export interface ContratDeleted {
  (value: ListItem): void;
}

export interface ContratTemplateCreated {
  (value: ListItem): void;
}

export interface ContratTemplateUpdated {
  (value: ListItem): void;
}

export interface ContratTemplateDeleted {
  (value: ListItem): void;
}

export interface CreneauCreated {
  (value: ListItem): void;
}

export interface CreneauUpdated {
  (value: ListItem): void;
}

export interface CreneauDeleted {
  (value: ListItem): void;
}

export interface DeliveryCreated {
  (value: ListItem): void;
}

export interface DeliveryUpdated {
  (value: ListItem): void;
}

export interface DeliveryDeleted {
  (value: ListItem): void;
}

export interface DocumentCreated {
  (value: ListItem): void;
}

export interface DocumentUpdated {
  (value: ListItem): void;
}

export interface DocumentDeleted {
  (value: ListItem): void;
}

export interface DocumentTypeCreated {
  (value: ListItem): void;
}

export interface DocumentTypeUpdated {
  (value: ListItem): void;
}

export interface DocumentTypeDeleted {
  (value: ListItem): void;
}

export interface EtablissementCreated {
  (value: ListItem): void;
}

export interface EtablissementUpdated {
  (value: ListItem): void;
}

export interface EtablissementDeleted {
  (value: ListItem): void;
}

export interface FractionDsnCreated {
  (value: ListItem): void;
}

export interface FractionDsnUpdated {
  (value: ListItem): void;
}

export interface FractionDsnDeleted {
  (value: ListItem): void;
}

export interface LieuCreated {
  (value: ListItem): void;
}

export interface LieuUpdated {
  (value: ListItem): void;
}

export interface LieuDeleted {
  (value: ListItem): void;
}

export interface MailCreated {
  (value: ListItem): void;
}

export interface MailUpdated {
  (value: ListItem): void;
}

export interface MailDeleted {
  (value: ListItem): void;
}

export interface ManualBillingDocumentCreated {
  (value: ListItem): void;
}

export interface ManualBillingDocumentUpdated {
  (value: ListItem): void;
}

export interface ManualBillingDocumentDeleted {
  (value: ListItem): void;
}

export interface MetaAttribCreated {
  (value: ListItem): void;
}

export interface MetaAttribUpdated {
  (value: ListItem): void;
}

export interface MetaAttribDeleted {
  (value: ListItem): void;
}

export interface NotifCreated {
  (value: ListItem): void;
}

export interface NotifUpdated {
  (value: ListItem): void;
}

export interface NotifDeleted {
  (value: ListItem): void;
}

export interface NumeroCreated {
  (value: ListItem): void;
}

export interface NumeroUpdated {
  (value: ListItem): void;
}

export interface NumeroDeleted {
  (value: ListItem): void;
}

export interface NumeroObjetCreated {
  (value: ListItem): void;
}

export interface NumeroObjetUpdated {
  (value: ListItem): void;
}

export interface NumeroObjetDeleted {
  (value: ListItem): void;
}

export interface ObjetMetierCreated {
  (value: ListItem): void;
}

export interface ObjetMetierUpdated {
  (value: ListItem): void;
}

export interface ObjetMetierDeleted {
  (value: ListItem): void;
}

export interface PaieCreated {
  (value: ListItem): void;
}

export interface PaieUpdated {
  (value: ListItem): void;
}

export interface PaieDeleted {
  (value: ListItem): void;
}

export interface PaymentMeansCreated {
  (value: ListItem): void;
}

export interface PaymentMeansUpdated {
  (value: ListItem): void;
}

export interface PaymentMeansDeleted {
  (value: ListItem): void;
}

export interface PlageCreneauCreated {
  (value: ListItem): void;
}

export interface PlageCreneauUpdated {
  (value: ListItem): void;
}

export interface PlageCreneauDeleted {
  (value: ListItem): void;
}

export interface ProjetCreated {
  (value: ListItem): void;
}

export interface ProjetUpdated {
  (value: ListItem): void;
}

export interface ProjetDeleted {
  (value: ListItem): void;
}

export interface QualiteCreated {
  (value: ListItem): void;
}

export interface QualiteUpdated {
  (value: ListItem): void;
}

export interface QualiteDeleted {
  (value: ListItem): void;
}

export interface RibCreated {
  (value: ListItem): void;
}

export interface RibUpdated {
  (value: ListItem): void;
}

export interface RibDeleted {
  (value: ListItem): void;
}

export interface RubriqueCreated {
  (value: ListItem): void;
}

export interface RubriqueUpdated {
  (value: ListItem): void;
}

export interface RubriqueDeleted {
  (value: ListItem): void;
}

export interface SalarieCreated {
  (value: ListItem): void;
}

export interface SalarieUpdated {
  (value: ListItem): void;
}

export interface SalarieDeleted {
  (value: ListItem): void;
}

export interface SubscriptionCreated {
  (value: ListItem): void;
}

export interface SubscriptionUpdated {
  (value: ListItem): void;
}

export interface SubscriptionDeleted {
  (value: ListItem): void;
}

export interface SubscriptionTypeCreated {
  (value: ListItem): void;
}

export interface SubscriptionTypeUpdated {
  (value: ListItem): void;
}

export interface SubscriptionTypeDeleted {
  (value: ListItem): void;
}

export interface SupportCreated {
  (value: ListItem): void;
}

export interface SupportUpdated {
  (value: ListItem): void;
}

export interface SupportDeleted {
  (value: ListItem): void;
}

export interface TransactionCreated {
  (value: ListItem): void;
}

export interface TransactionUpdated {
  (value: ListItem): void;
}

export interface TransactionDeleted {
  (value: ListItem): void;
}

export interface UserCreated {
  (value: ListItem): void;
}

export interface UserUpdated {
  (value: ListItem): void;
}

export interface UserDeleted {
  (value: ListItem): void;
}

export interface WizardItemCreated {
  (value: ListItem): void;
}

export interface WizardItemUpdated {
  (value: ListItem): void;
}

export interface WizardItemDeleted {
  (value: ListItem): void;
}

export default class HubServices {
  public static connection: signalR.HubConnection;
  private static ready = false;
  private static dialogRegistered = false;
  private static dialogRegistration: Promise<void> | null = null;

  public static hubReady (): boolean {
    return HubServices.ready;
  }

  public static setConnection (connection: signalR.HubConnection, ready: boolean) {
    HubServices.connection = connection;
    HubServices.ready = ready;
    if (!ready) {
      HubServices.dialogRegistered = false;
      HubServices.dialogRegistration = null;
    }
    if (ready) {
      if (HubServices.contratSignContrat != null) {
        HubServices.onContratSignContrat(HubServices.contratSignContrat);
      }
      if (HubServices.etablissementFractionUpdated != null) {
        HubServices.onEtablissementFractionUpdated(HubServices.etablissementFractionUpdated);
      }
      if (HubServices.synchro98Progress != null) {
        HubServices.onSynchro98Progress(HubServices.synchro98Progress);
      }
      if (HubServices.routeShowRoute != null) {
        HubServices.onRouteShowRoute(HubServices.routeShowRoute);
      }
      if (HubServices.filesProgress != null) {
        HubServices.onFilesProgress(HubServices.filesProgress);
      }
      if (HubServices.chatItemCreated != null) {
        HubServices.onChatItemCreated(HubServices.chatItemCreated);
      }
      if (HubServices.dialogQuestion != null) {
        HubServices.onDialogQuestion(HubServices.dialogQuestion);
      }
      if (HubServices.dialogAction != null) {
        HubServices.onDialogAction(HubServices.dialogAction);
      }
      if (HubServices.dialogRefresh != null) {
        HubServices.onDialogRefresh(HubServices.dialogRefresh);
      }
      if (HubServices.cartUpdated != null) {
        HubServices.onCartUpdated(HubServices.cartUpdated);
      }
      if (HubServices.cartTagUpdated != null) {
        HubServices.onCartTagUpdated(HubServices.cartTagUpdated);
      }
      if (HubServices.transactionRapproched != null) {
        HubServices.onTransactionRapproched(HubServices.transactionRapproched);
      }
      if (HubServices.carteLoadPaybox != null) {
        HubServices.onCarteLoadPaybox(HubServices.carteLoadPaybox);
      }
      if (HubServices.graphDataAdditional != null) {
        HubServices.onGraphDataAdditional(HubServices.graphDataAdditional);
      }
      if (HubServices.metaAttribDefine != null) {
        HubServices.onMetaAttribDefine(HubServices.metaAttribDefine);
      }
      if (HubServices.dashboardWidgetUpdated != null) {
        HubServices.onDashboardWidgetUpdated(HubServices.dashboardWidgetUpdated);
      }
      if (HubServices.accidentTravailCreated != null) {
        HubServices.registerAccidentTravail(HubServices.accidentTravailCreated, HubServices.accidentTravailUpdated, HubServices.accidentTravailDeleted);
      }
      if (HubServices.accountEntryCreated != null) {
        HubServices.registerAccountEntry(HubServices.accountEntryCreated, HubServices.accountEntryUpdated, HubServices.accountEntryDeleted);
      }
      if (HubServices.activiteCreated != null) {
        HubServices.registerActivite(HubServices.activiteCreated, HubServices.activiteUpdated, HubServices.activiteDeleted);
      }
      if (HubServices.actualiteCreated != null) {
        HubServices.registerActualite(HubServices.actualiteCreated, HubServices.actualiteUpdated, HubServices.actualiteDeleted);
      }
      if (HubServices.adresseCreated != null) {
        HubServices.registerAdresse(HubServices.adresseCreated, HubServices.adresseUpdated, HubServices.adresseDeleted);
      }
      if (HubServices.apprentiCreated != null) {
        HubServices.registerApprenti(HubServices.apprentiCreated, HubServices.apprentiUpdated, HubServices.apprentiDeleted);
      }
      if (HubServices.attestationCreated != null) {
        HubServices.registerAttestation(HubServices.attestationCreated, HubServices.attestationUpdated, HubServices.attestationDeleted);
      }
      if (HubServices.attestationDefCreated != null) {
        HubServices.registerAttestationDef(HubServices.attestationDefCreated, HubServices.attestationDefUpdated, HubServices.attestationDefDeleted);
      }
      if (HubServices.authorizedCreditCreated != null) {
        HubServices.registerAuthorizedCredit(HubServices.authorizedCreditCreated, HubServices.authorizedCreditUpdated, HubServices.authorizedCreditDeleted);
      }
      if (HubServices.bankCreated != null) {
        HubServices.registerBank(HubServices.bankCreated, HubServices.bankUpdated, HubServices.bankDeleted);
      }
      if (HubServices.billCreated != null) {
        HubServices.registerBill(HubServices.billCreated, HubServices.billUpdated, HubServices.billDeleted);
      }
      if (HubServices.chatCreated != null) {
        HubServices.registerChat(HubServices.chatCreated, HubServices.chatUpdated, HubServices.chatDeleted);
      }
      if (HubServices.civiliteCreated != null) {
        HubServices.registerCivilite(HubServices.civiliteCreated, HubServices.civiliteUpdated, HubServices.civiliteDeleted);
      }
      if (HubServices.clientCreated != null) {
        HubServices.registerClient(HubServices.clientCreated, HubServices.clientUpdated, HubServices.clientDeleted);
      }
      if (HubServices.contactCreated != null) {
        HubServices.registerContact(HubServices.contactCreated, HubServices.contactUpdated, HubServices.contactDeleted);
      }
      if (HubServices.contratCreated != null) {
        HubServices.registerContrat(HubServices.contratCreated, HubServices.contratUpdated, HubServices.contratDeleted);
      }
      if (HubServices.contratTemplateCreated != null) {
        HubServices.registerContratTemplate(HubServices.contratTemplateCreated, HubServices.contratTemplateUpdated, HubServices.contratTemplateDeleted);
      }
      if (HubServices.creneauCreated != null) {
        HubServices.registerCreneau(HubServices.creneauCreated, HubServices.creneauUpdated, HubServices.creneauDeleted);
      }
      if (HubServices.deliveryCreated != null) {
        HubServices.registerDelivery(HubServices.deliveryCreated, HubServices.deliveryUpdated, HubServices.deliveryDeleted);
      }
      if (HubServices.documentCreated != null) {
        HubServices.registerDocument(HubServices.documentCreated, HubServices.documentUpdated, HubServices.documentDeleted);
      }
      if (HubServices.documentTypeCreated != null) {
        HubServices.registerDocumentType(HubServices.documentTypeCreated, HubServices.documentTypeUpdated, HubServices.documentTypeDeleted);
      }
      if (HubServices.etablissementCreated != null) {
        HubServices.registerEtablissement(HubServices.etablissementCreated, HubServices.etablissementUpdated, HubServices.etablissementDeleted);
      }
      if (HubServices.fractionDsnCreated != null) {
        HubServices.registerFractionDsn(HubServices.fractionDsnCreated, HubServices.fractionDsnUpdated, HubServices.fractionDsnDeleted);
      }
      if (HubServices.lieuCreated != null) {
        HubServices.registerLieu(HubServices.lieuCreated, HubServices.lieuUpdated, HubServices.lieuDeleted);
      }
      if (HubServices.mailCreated != null) {
        HubServices.registerMail(HubServices.mailCreated, HubServices.mailUpdated, HubServices.mailDeleted);
      }
      if (HubServices.manualBillingDocumentCreated != null) {
        HubServices.registerManualBillingDocument(HubServices.manualBillingDocumentCreated, HubServices.manualBillingDocumentUpdated, HubServices.manualBillingDocumentDeleted);
      }
      if (HubServices.metaAttribCreated != null) {
        HubServices.registerMetaAttrib(HubServices.metaAttribCreated, HubServices.metaAttribUpdated, HubServices.metaAttribDeleted);
      }
      if (HubServices.notifCreated != null) {
        HubServices.registerNotif(HubServices.notifCreated, HubServices.notifUpdated, HubServices.notifDeleted);
      }
      if (HubServices.numeroCreated != null) {
        HubServices.registerNumero(HubServices.numeroCreated, HubServices.numeroUpdated, HubServices.numeroDeleted);
      }
      if (HubServices.numeroObjetCreated != null) {
        HubServices.registerNumeroObjet(HubServices.numeroObjetCreated, HubServices.numeroObjetUpdated, HubServices.numeroObjetDeleted);
      }
      if (HubServices.objetMetierCreated != null) {
        HubServices.registerObjetMetier(HubServices.objetMetierCreated, HubServices.objetMetierUpdated, HubServices.objetMetierDeleted);
      }
      if (HubServices.paieCreated != null) {
        HubServices.registerPaie(HubServices.paieCreated, HubServices.paieUpdated, HubServices.paieDeleted);
      }
      if (HubServices.paymentMeansCreated != null) {
        HubServices.registerPaymentMeans(HubServices.paymentMeansCreated, HubServices.paymentMeansUpdated, HubServices.paymentMeansDeleted);
      }
      if (HubServices.plageCreneauCreated != null) {
        HubServices.registerPlageCreneau(HubServices.plageCreneauCreated, HubServices.plageCreneauUpdated, HubServices.plageCreneauDeleted);
      }
      if (HubServices.projetCreated != null) {
        HubServices.registerProjet(HubServices.projetCreated, HubServices.projetUpdated, HubServices.projetDeleted);
      }
      if (HubServices.qualiteCreated != null) {
        HubServices.registerQualite(HubServices.qualiteCreated, HubServices.qualiteUpdated, HubServices.qualiteDeleted);
      }
      if (HubServices.ribCreated != null) {
        HubServices.registerRib(HubServices.ribCreated, HubServices.ribUpdated, HubServices.ribDeleted);
      }
      if (HubServices.rubriqueCreated != null) {
        HubServices.registerRubrique(HubServices.rubriqueCreated, HubServices.rubriqueUpdated, HubServices.rubriqueDeleted);
      }
      if (HubServices.salarieCreated != null) {
        HubServices.registerSalarie(HubServices.salarieCreated, HubServices.salarieUpdated, HubServices.salarieDeleted);
      }
      if (HubServices.subscriptionCreated != null) {
        HubServices.registerSubscription(HubServices.subscriptionCreated, HubServices.subscriptionUpdated, HubServices.subscriptionDeleted);
      }
      if (HubServices.subscriptionTypeCreated != null) {
        HubServices.registerSubscriptionType(HubServices.subscriptionTypeCreated, HubServices.subscriptionTypeUpdated, HubServices.subscriptionTypeDeleted);
      }
      if (HubServices.supportCreated != null) {
        HubServices.registerSupport(HubServices.supportCreated, HubServices.supportUpdated, HubServices.supportDeleted);
      }
      if (HubServices.transactionCreated != null) {
        HubServices.registerTransaction(HubServices.transactionCreated, HubServices.transactionUpdated, HubServices.transactionDeleted);
      }
      if (HubServices.userCreated != null) {
        HubServices.registerUser(HubServices.userCreated, HubServices.userUpdated, HubServices.userDeleted);
      }
      if (HubServices.wizardItemCreated != null) {
        HubServices.registerWizardItem(HubServices.wizardItemCreated, HubServices.wizardItemUpdated, HubServices.wizardItemDeleted);
      }
    }
  }

  private static contratSignContrat: ContratSignContrat;
  private static readonly contratSignContratHandler = (value: string): void => {
    HubServices.contratSignContrat?.(value);
  };
  public static onContratSignContrat (contratSignContrat: ContratSignContrat) {
    HubServices.contratSignContrat = contratSignContrat;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContrat', storeSession.httpToken);
      HubServices.connection.off('ContratSignContrat', HubServices.contratSignContratHandler);
      HubServices.connection.on('ContratSignContrat', HubServices.contratSignContratHandler);
    }
  }

  private static etablissementFractionUpdated: EtablissementFractionUpdated;
  private static readonly etablissementFractionUpdatedHandler = (value: Etablissement): void => {
    HubServices.etablissementFractionUpdated?.(value);
  };
  public static onEtablissementFractionUpdated (etablissementFractionUpdated: EtablissementFractionUpdated) {
    HubServices.etablissementFractionUpdated = etablissementFractionUpdated;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterEtablissement', storeSession.httpToken);
      HubServices.connection.off('EtablissementFractionUpdated', HubServices.etablissementFractionUpdatedHandler);
      HubServices.connection.on('EtablissementFractionUpdated', HubServices.etablissementFractionUpdatedHandler);
    }
  }

  private static synchro98Progress: Synchro98Progress;
  private static readonly synchro98ProgressHandler = (value: Synchro98): void => {
    HubServices.synchro98Progress?.(value);
  };
  public static onSynchro98Progress (synchro98Progress: Synchro98Progress) {
    HubServices.synchro98Progress = synchro98Progress;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSynchro98', storeSession.httpToken);
      HubServices.connection.off('Synchro98Progress', HubServices.synchro98ProgressHandler);
      HubServices.connection.on('Synchro98Progress', HubServices.synchro98ProgressHandler);
    }
  }

  private static routeShowRoute: RouteShowRoute;
  private static readonly routeShowRouteHandler = (value: Route): void => {
    HubServices.routeShowRoute?.(value);
  };
  public static onRouteShowRoute (routeShowRoute: RouteShowRoute) {
    HubServices.routeShowRoute = routeShowRoute;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRoute', storeSession.httpToken);
      HubServices.connection.off('RouteShowRoute', HubServices.routeShowRouteHandler);
      HubServices.connection.on('RouteShowRoute', HubServices.routeShowRouteHandler);
    }
  }

  private static filesProgress: FilesProgress;
  private static readonly filesProgressHandler = (value: string): void => {
    HubServices.filesProgress?.(value);
  };
  public static onFilesProgress (filesProgress: FilesProgress) {
    HubServices.filesProgress = filesProgress;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterFiles', storeSession.httpToken);
      HubServices.connection.off('FilesProgress', HubServices.filesProgressHandler);
      HubServices.connection.on('FilesProgress', HubServices.filesProgressHandler);
    }
  }

  private static chatItemCreated: ChatItemCreated;
  private static readonly chatItemCreatedHandler = (value: ChatItem): void => {
    HubServices.chatItemCreated?.(value);
  };
  public static onChatItemCreated (chatItemCreated: ChatItemCreated) {
    HubServices.chatItemCreated = chatItemCreated;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterChat', storeSession.httpToken);
      HubServices.connection.off('ChatItemCreated', HubServices.chatItemCreatedHandler);
      HubServices.connection.on('ChatItemCreated', HubServices.chatItemCreatedHandler);
    }
  }

  private static dialogQuestion: DialogQuestion;
  private static readonly dialogQuestionHandler = (value: Dialog): void => {
    HubServices.dialogQuestion?.(value);
  };
  public static onDialogQuestion (dialogQuestion: DialogQuestion) {
    HubServices.dialogQuestion = dialogQuestion;
    HubServices.registerDialog();
  }

  private static dialogAction: DialogAction;
  private static readonly dialogActionHandler = (value: DialogActionData): void => {
    HubServices.dialogAction?.(value);
  };
  public static onDialogAction (dialogAction: DialogAction) {
    HubServices.dialogAction = dialogAction;
    HubServices.registerDialog();
  }

  private static dialogRefresh: DialogRefresh;
  private static readonly dialogRefreshHandler = (value: Dialog): void => {
    HubServices.dialogRefresh?.(value);
  };
  public static onDialogRefresh (dialogRefresh: DialogRefresh) {
    HubServices.dialogRefresh = dialogRefresh;
    HubServices.registerDialog();
  }

  private static cartUpdated: CartUpdated;
  private static readonly cartUpdatedHandler = (value: Cart): void => {
    HubServices.cartUpdated?.(value);
  };
  public static onCartUpdated (cartUpdated: CartUpdated) {
    HubServices.cartUpdated = cartUpdated;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCart', storeSession.httpToken);
      HubServices.connection.off('CartUpdated', HubServices.cartUpdatedHandler);
      HubServices.connection.on('CartUpdated', HubServices.cartUpdatedHandler);
    }
  }

  private static cartTagUpdated: CartTagUpdated;
  private static readonly cartTagUpdatedHandler = (value: Cart): void => {
    HubServices.cartTagUpdated?.(value);
  };
  public static onCartTagUpdated (cartTagUpdated: CartTagUpdated) {
    HubServices.cartTagUpdated = cartTagUpdated;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCart', storeSession.httpToken);
      HubServices.connection.off('CartTagUpdated', HubServices.cartTagUpdatedHandler);
      HubServices.connection.on('CartTagUpdated', HubServices.cartTagUpdatedHandler);
    }
  }

  private static transactionRapproched: TransactionRapproched;
  private static readonly transactionRapprochedHandler = (value: boolean): void => {
    HubServices.transactionRapproched?.(value);
  };
  public static onTransactionRapproched (transactionRapproched: TransactionRapproched) {
    HubServices.transactionRapproched = transactionRapproched;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterTransaction', storeSession.httpToken);
      HubServices.connection.off('TransactionRapproched', HubServices.transactionRapprochedHandler);
      HubServices.connection.on('TransactionRapproched', HubServices.transactionRapprochedHandler);
    }
  }

  private static carteLoadPaybox: CarteLoadPaybox;
  private static readonly carteLoadPayboxHandler = (value: PayboxData): void => {
    HubServices.carteLoadPaybox?.(value);
  };
  public static onCarteLoadPaybox (carteLoadPaybox: CarteLoadPaybox) {
    HubServices.carteLoadPaybox = carteLoadPaybox;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCarte', storeSession.httpToken);
      HubServices.connection.off('CarteLoadPaybox', HubServices.carteLoadPayboxHandler);
      HubServices.connection.on('CarteLoadPaybox', HubServices.carteLoadPayboxHandler);
    }
  }

  private static graphDataAdditional: GraphDataAdditional;
  private static readonly graphDataAdditionalHandler = (value: GraphData): void => {
    HubServices.graphDataAdditional?.(value);
  };
  public static onGraphDataAdditional (graphDataAdditional: GraphDataAdditional) {
    HubServices.graphDataAdditional = graphDataAdditional;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterGraphData', storeSession.httpToken);
      HubServices.connection.off('GraphDataAdditional', HubServices.graphDataAdditionalHandler);
      HubServices.connection.on('GraphDataAdditional', HubServices.graphDataAdditionalHandler);
    }
  }

  private static metaAttribDefine: MetaAttribDefine;
  private static readonly metaAttribDefineHandler = (value: MetaAttrib): void => {
    HubServices.metaAttribDefine?.(value);
  };
  public static onMetaAttribDefine (metaAttribDefine: MetaAttribDefine) {
    HubServices.metaAttribDefine = metaAttribDefine;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMetaAttrib', storeSession.httpToken);
      HubServices.connection.off('MetaAttribDefine', HubServices.metaAttribDefineHandler);
      HubServices.connection.on('MetaAttribDefine', HubServices.metaAttribDefineHandler);
    }
  }

  private static dashboardWidgetUpdated: DashboardWidgetUpdated;
  private static readonly dashboardWidgetUpdatedHandler = (value: WidgetData): void => {
    HubServices.dashboardWidgetUpdated?.(value);
  };
  public static onDashboardWidgetUpdated (dashboardWidgetUpdated: DashboardWidgetUpdated) {
    HubServices.dashboardWidgetUpdated = dashboardWidgetUpdated;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDashboardWidget', storeSession.httpToken);
      HubServices.connection.off('DashboardWidgetUpdated', HubServices.dashboardWidgetUpdatedHandler);
      HubServices.connection.on('DashboardWidgetUpdated', HubServices.dashboardWidgetUpdatedHandler);
    }
  }

  private static registerDialog (): void {
    if (!HubServices.ready || HubServices.dialogRegistered || HubServices.dialogRegistration != null) {
      return;
    }

    const connection = HubServices.connection;
    connection.off('DialogQuestion', HubServices.dialogQuestionHandler);
    connection.off('DialogAction', HubServices.dialogActionHandler);
    connection.off('DialogRefresh', HubServices.dialogRefreshHandler);
    connection.on('DialogQuestion', HubServices.dialogQuestionHandler);
    connection.on('DialogAction', HubServices.dialogActionHandler);
    connection.on('DialogRefresh', HubServices.dialogRefreshHandler);

    const registration = connection.invoke('EnterDialog', storeSession.httpToken)
      .then(() => {
        if (HubServices.ready && HubServices.connection === connection) {
          HubServices.dialogRegistered = true;
        }
      })
      .catch((error: unknown) => {
        console.error('Unable to register dialog hub', error);
        setTimeout(() => HubServices.registerDialog(), 1000);
      })
      .finally(() => {
        if (HubServices.dialogRegistration === registration) {
          HubServices.dialogRegistration = null;
        }
      });
    HubServices.dialogRegistration = registration;
  }

  private static accidentTravailCreated: AccidentTravailCreated;
  private static accidentTravailUpdated: AccidentTravailUpdated;
  private static accidentTravailDeleted: AccidentTravailDeleted;
  private static readonly accidentTravailCreatedHandler = (value: ListItem): void => HubServices.accidentTravailCreated?.(value);
  private static readonly accidentTravailUpdatedHandler = (value: ListItem): void => HubServices.accidentTravailUpdated?.(value);
  private static readonly accidentTravailDeletedHandler = (value: ListItem): void => HubServices.accidentTravailDeleted?.(value);
  public static registerAccidentTravail (created: AccidentTravailCreated, updated: AccidentTravailUpdated, deleted: AccidentTravailDeleted) {
    HubServices.accidentTravailCreated = created;
    HubServices.accidentTravailUpdated = updated;
    HubServices.accidentTravailDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAccidentTravail', storeSession.httpToken);
      HubServices.connection.off('AccidentTravailCreated', HubServices.accidentTravailCreatedHandler);
      HubServices.connection.on('AccidentTravailCreated', HubServices.accidentTravailCreatedHandler);
      HubServices.connection.off('AccidentTravailUpdated', HubServices.accidentTravailUpdatedHandler);
      HubServices.connection.on('AccidentTravailUpdated', HubServices.accidentTravailUpdatedHandler);
      HubServices.connection.off('AccidentTravailDeleted', HubServices.accidentTravailDeletedHandler);
      HubServices.connection.on('AccidentTravailDeleted', HubServices.accidentTravailDeletedHandler);
    }
  }

  private static accountEntryCreated: AccountEntryCreated;
  private static accountEntryUpdated: AccountEntryUpdated;
  private static accountEntryDeleted: AccountEntryDeleted;
  private static readonly accountEntryCreatedHandler = (value: ListItem): void => HubServices.accountEntryCreated?.(value);
  private static readonly accountEntryUpdatedHandler = (value: ListItem): void => HubServices.accountEntryUpdated?.(value);
  private static readonly accountEntryDeletedHandler = (value: ListItem): void => HubServices.accountEntryDeleted?.(value);
  public static registerAccountEntry (created: AccountEntryCreated, updated: AccountEntryUpdated, deleted: AccountEntryDeleted) {
    HubServices.accountEntryCreated = created;
    HubServices.accountEntryUpdated = updated;
    HubServices.accountEntryDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAccountEntry', storeSession.httpToken);
      HubServices.connection.off('AccountEntryCreated', HubServices.accountEntryCreatedHandler);
      HubServices.connection.on('AccountEntryCreated', HubServices.accountEntryCreatedHandler);
      HubServices.connection.off('AccountEntryUpdated', HubServices.accountEntryUpdatedHandler);
      HubServices.connection.on('AccountEntryUpdated', HubServices.accountEntryUpdatedHandler);
      HubServices.connection.off('AccountEntryDeleted', HubServices.accountEntryDeletedHandler);
      HubServices.connection.on('AccountEntryDeleted', HubServices.accountEntryDeletedHandler);
    }
  }

  private static activiteCreated: ActiviteCreated;
  private static activiteUpdated: ActiviteUpdated;
  private static activiteDeleted: ActiviteDeleted;
  private static readonly activiteCreatedHandler = (value: ListItem): void => HubServices.activiteCreated?.(value);
  private static readonly activiteUpdatedHandler = (value: ListItem): void => HubServices.activiteUpdated?.(value);
  private static readonly activiteDeletedHandler = (value: ListItem): void => HubServices.activiteDeleted?.(value);
  public static registerActivite (created: ActiviteCreated, updated: ActiviteUpdated, deleted: ActiviteDeleted) {
    HubServices.activiteCreated = created;
    HubServices.activiteUpdated = updated;
    HubServices.activiteDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterActivite', storeSession.httpToken);
      HubServices.connection.off('ActiviteCreated', HubServices.activiteCreatedHandler);
      HubServices.connection.on('ActiviteCreated', HubServices.activiteCreatedHandler);
      HubServices.connection.off('ActiviteUpdated', HubServices.activiteUpdatedHandler);
      HubServices.connection.on('ActiviteUpdated', HubServices.activiteUpdatedHandler);
      HubServices.connection.off('ActiviteDeleted', HubServices.activiteDeletedHandler);
      HubServices.connection.on('ActiviteDeleted', HubServices.activiteDeletedHandler);
    }
  }

  private static actualiteCreated: ActualiteCreated;
  private static actualiteUpdated: ActualiteUpdated;
  private static actualiteDeleted: ActualiteDeleted;
  private static readonly actualiteCreatedHandler = (value: ListItem): void => HubServices.actualiteCreated?.(value);
  private static readonly actualiteUpdatedHandler = (value: ListItem): void => HubServices.actualiteUpdated?.(value);
  private static readonly actualiteDeletedHandler = (value: ListItem): void => HubServices.actualiteDeleted?.(value);
  public static registerActualite (created: ActualiteCreated, updated: ActualiteUpdated, deleted: ActualiteDeleted) {
    HubServices.actualiteCreated = created;
    HubServices.actualiteUpdated = updated;
    HubServices.actualiteDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterActualite', storeSession.httpToken);
      HubServices.connection.off('ActualiteCreated', HubServices.actualiteCreatedHandler);
      HubServices.connection.on('ActualiteCreated', HubServices.actualiteCreatedHandler);
      HubServices.connection.off('ActualiteUpdated', HubServices.actualiteUpdatedHandler);
      HubServices.connection.on('ActualiteUpdated', HubServices.actualiteUpdatedHandler);
      HubServices.connection.off('ActualiteDeleted', HubServices.actualiteDeletedHandler);
      HubServices.connection.on('ActualiteDeleted', HubServices.actualiteDeletedHandler);
    }
  }

  private static adresseCreated: AdresseCreated;
  private static adresseUpdated: AdresseUpdated;
  private static adresseDeleted: AdresseDeleted;
  private static readonly adresseCreatedHandler = (value: ListItem): void => HubServices.adresseCreated?.(value);
  private static readonly adresseUpdatedHandler = (value: ListItem): void => HubServices.adresseUpdated?.(value);
  private static readonly adresseDeletedHandler = (value: ListItem): void => HubServices.adresseDeleted?.(value);
  public static registerAdresse (created: AdresseCreated, updated: AdresseUpdated, deleted: AdresseDeleted) {
    HubServices.adresseCreated = created;
    HubServices.adresseUpdated = updated;
    HubServices.adresseDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAdresse', storeSession.httpToken);
      HubServices.connection.off('AdresseCreated', HubServices.adresseCreatedHandler);
      HubServices.connection.on('AdresseCreated', HubServices.adresseCreatedHandler);
      HubServices.connection.off('AdresseUpdated', HubServices.adresseUpdatedHandler);
      HubServices.connection.on('AdresseUpdated', HubServices.adresseUpdatedHandler);
      HubServices.connection.off('AdresseDeleted', HubServices.adresseDeletedHandler);
      HubServices.connection.on('AdresseDeleted', HubServices.adresseDeletedHandler);
    }
  }

  private static apprentiCreated: ApprentiCreated;
  private static apprentiUpdated: ApprentiUpdated;
  private static apprentiDeleted: ApprentiDeleted;
  private static readonly apprentiCreatedHandler = (value: ListItem): void => HubServices.apprentiCreated?.(value);
  private static readonly apprentiUpdatedHandler = (value: ListItem): void => HubServices.apprentiUpdated?.(value);
  private static readonly apprentiDeletedHandler = (value: ListItem): void => HubServices.apprentiDeleted?.(value);
  public static registerApprenti (created: ApprentiCreated, updated: ApprentiUpdated, deleted: ApprentiDeleted) {
    HubServices.apprentiCreated = created;
    HubServices.apprentiUpdated = updated;
    HubServices.apprentiDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterApprenti', storeSession.httpToken);
      HubServices.connection.off('ApprentiCreated', HubServices.apprentiCreatedHandler);
      HubServices.connection.on('ApprentiCreated', HubServices.apprentiCreatedHandler);
      HubServices.connection.off('ApprentiUpdated', HubServices.apprentiUpdatedHandler);
      HubServices.connection.on('ApprentiUpdated', HubServices.apprentiUpdatedHandler);
      HubServices.connection.off('ApprentiDeleted', HubServices.apprentiDeletedHandler);
      HubServices.connection.on('ApprentiDeleted', HubServices.apprentiDeletedHandler);
    }
  }

  private static attestationCreated: AttestationCreated;
  private static attestationUpdated: AttestationUpdated;
  private static attestationDeleted: AttestationDeleted;
  private static readonly attestationCreatedHandler = (value: ListItem): void => HubServices.attestationCreated?.(value);
  private static readonly attestationUpdatedHandler = (value: ListItem): void => HubServices.attestationUpdated?.(value);
  private static readonly attestationDeletedHandler = (value: ListItem): void => HubServices.attestationDeleted?.(value);
  public static registerAttestation (created: AttestationCreated, updated: AttestationUpdated, deleted: AttestationDeleted) {
    HubServices.attestationCreated = created;
    HubServices.attestationUpdated = updated;
    HubServices.attestationDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAttestation', storeSession.httpToken);
      HubServices.connection.off('AttestationCreated', HubServices.attestationCreatedHandler);
      HubServices.connection.on('AttestationCreated', HubServices.attestationCreatedHandler);
      HubServices.connection.off('AttestationUpdated', HubServices.attestationUpdatedHandler);
      HubServices.connection.on('AttestationUpdated', HubServices.attestationUpdatedHandler);
      HubServices.connection.off('AttestationDeleted', HubServices.attestationDeletedHandler);
      HubServices.connection.on('AttestationDeleted', HubServices.attestationDeletedHandler);
    }
  }

  private static attestationDefCreated: AttestationDefCreated;
  private static attestationDefUpdated: AttestationDefUpdated;
  private static attestationDefDeleted: AttestationDefDeleted;
  private static readonly attestationDefCreatedHandler = (value: ListItem): void => HubServices.attestationDefCreated?.(value);
  private static readonly attestationDefUpdatedHandler = (value: ListItem): void => HubServices.attestationDefUpdated?.(value);
  private static readonly attestationDefDeletedHandler = (value: ListItem): void => HubServices.attestationDefDeleted?.(value);
  public static registerAttestationDef (created: AttestationDefCreated, updated: AttestationDefUpdated, deleted: AttestationDefDeleted) {
    HubServices.attestationDefCreated = created;
    HubServices.attestationDefUpdated = updated;
    HubServices.attestationDefDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAttestationDef', storeSession.httpToken);
      HubServices.connection.off('AttestationDefCreated', HubServices.attestationDefCreatedHandler);
      HubServices.connection.on('AttestationDefCreated', HubServices.attestationDefCreatedHandler);
      HubServices.connection.off('AttestationDefUpdated', HubServices.attestationDefUpdatedHandler);
      HubServices.connection.on('AttestationDefUpdated', HubServices.attestationDefUpdatedHandler);
      HubServices.connection.off('AttestationDefDeleted', HubServices.attestationDefDeletedHandler);
      HubServices.connection.on('AttestationDefDeleted', HubServices.attestationDefDeletedHandler);
    }
  }

  private static authorizedCreditCreated: AuthorizedCreditCreated;
  private static authorizedCreditUpdated: AuthorizedCreditUpdated;
  private static authorizedCreditDeleted: AuthorizedCreditDeleted;
  private static readonly authorizedCreditCreatedHandler = (value: ListItem): void => HubServices.authorizedCreditCreated?.(value);
  private static readonly authorizedCreditUpdatedHandler = (value: ListItem): void => HubServices.authorizedCreditUpdated?.(value);
  private static readonly authorizedCreditDeletedHandler = (value: ListItem): void => HubServices.authorizedCreditDeleted?.(value);
  public static registerAuthorizedCredit (created: AuthorizedCreditCreated, updated: AuthorizedCreditUpdated, deleted: AuthorizedCreditDeleted) {
    HubServices.authorizedCreditCreated = created;
    HubServices.authorizedCreditUpdated = updated;
    HubServices.authorizedCreditDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAuthorizedCredit', storeSession.httpToken);
      HubServices.connection.off('AuthorizedCreditCreated', HubServices.authorizedCreditCreatedHandler);
      HubServices.connection.on('AuthorizedCreditCreated', HubServices.authorizedCreditCreatedHandler);
      HubServices.connection.off('AuthorizedCreditUpdated', HubServices.authorizedCreditUpdatedHandler);
      HubServices.connection.on('AuthorizedCreditUpdated', HubServices.authorizedCreditUpdatedHandler);
      HubServices.connection.off('AuthorizedCreditDeleted', HubServices.authorizedCreditDeletedHandler);
      HubServices.connection.on('AuthorizedCreditDeleted', HubServices.authorizedCreditDeletedHandler);
    }
  }

  private static bankCreated: BankCreated;
  private static bankUpdated: BankUpdated;
  private static bankDeleted: BankDeleted;
  private static readonly bankCreatedHandler = (value: ListItem): void => HubServices.bankCreated?.(value);
  private static readonly bankUpdatedHandler = (value: ListItem): void => HubServices.bankUpdated?.(value);
  private static readonly bankDeletedHandler = (value: ListItem): void => HubServices.bankDeleted?.(value);
  public static registerBank (created: BankCreated, updated: BankUpdated, deleted: BankDeleted) {
    HubServices.bankCreated = created;
    HubServices.bankUpdated = updated;
    HubServices.bankDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterBank', storeSession.httpToken);
      HubServices.connection.off('BankCreated', HubServices.bankCreatedHandler);
      HubServices.connection.on('BankCreated', HubServices.bankCreatedHandler);
      HubServices.connection.off('BankUpdated', HubServices.bankUpdatedHandler);
      HubServices.connection.on('BankUpdated', HubServices.bankUpdatedHandler);
      HubServices.connection.off('BankDeleted', HubServices.bankDeletedHandler);
      HubServices.connection.on('BankDeleted', HubServices.bankDeletedHandler);
    }
  }

  private static billCreated: BillCreated;
  private static billUpdated: BillUpdated;
  private static billDeleted: BillDeleted;
  private static readonly billCreatedHandler = (value: ListItem): void => HubServices.billCreated?.(value);
  private static readonly billUpdatedHandler = (value: ListItem): void => HubServices.billUpdated?.(value);
  private static readonly billDeletedHandler = (value: ListItem): void => HubServices.billDeleted?.(value);
  public static registerBill (created: BillCreated, updated: BillUpdated, deleted: BillDeleted) {
    HubServices.billCreated = created;
    HubServices.billUpdated = updated;
    HubServices.billDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterBill', storeSession.httpToken);
      HubServices.connection.off('BillCreated', HubServices.billCreatedHandler);
      HubServices.connection.on('BillCreated', HubServices.billCreatedHandler);
      HubServices.connection.off('BillUpdated', HubServices.billUpdatedHandler);
      HubServices.connection.on('BillUpdated', HubServices.billUpdatedHandler);
      HubServices.connection.off('BillDeleted', HubServices.billDeletedHandler);
      HubServices.connection.on('BillDeleted', HubServices.billDeletedHandler);
    }
  }

  private static chatCreated: ChatCreated;
  private static chatUpdated: ChatUpdated;
  private static chatDeleted: ChatDeleted;
  private static readonly chatCreatedHandler = (value: ListItem): void => HubServices.chatCreated?.(value);
  private static readonly chatUpdatedHandler = (value: ListItem): void => HubServices.chatUpdated?.(value);
  private static readonly chatDeletedHandler = (value: ListItem): void => HubServices.chatDeleted?.(value);
  public static registerChat (created: ChatCreated, updated: ChatUpdated, deleted: ChatDeleted) {
    HubServices.chatCreated = created;
    HubServices.chatUpdated = updated;
    HubServices.chatDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterChat', storeSession.httpToken);
      HubServices.connection.off('ChatCreated', HubServices.chatCreatedHandler);
      HubServices.connection.on('ChatCreated', HubServices.chatCreatedHandler);
      HubServices.connection.off('ChatUpdated', HubServices.chatUpdatedHandler);
      HubServices.connection.on('ChatUpdated', HubServices.chatUpdatedHandler);
      HubServices.connection.off('ChatDeleted', HubServices.chatDeletedHandler);
      HubServices.connection.on('ChatDeleted', HubServices.chatDeletedHandler);
    }
  }

  private static civiliteCreated: CiviliteCreated;
  private static civiliteUpdated: CiviliteUpdated;
  private static civiliteDeleted: CiviliteDeleted;
  private static readonly civiliteCreatedHandler = (value: ListItem): void => HubServices.civiliteCreated?.(value);
  private static readonly civiliteUpdatedHandler = (value: ListItem): void => HubServices.civiliteUpdated?.(value);
  private static readonly civiliteDeletedHandler = (value: ListItem): void => HubServices.civiliteDeleted?.(value);
  public static registerCivilite (created: CiviliteCreated, updated: CiviliteUpdated, deleted: CiviliteDeleted) {
    HubServices.civiliteCreated = created;
    HubServices.civiliteUpdated = updated;
    HubServices.civiliteDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCivilite', storeSession.httpToken);
      HubServices.connection.off('CiviliteCreated', HubServices.civiliteCreatedHandler);
      HubServices.connection.on('CiviliteCreated', HubServices.civiliteCreatedHandler);
      HubServices.connection.off('CiviliteUpdated', HubServices.civiliteUpdatedHandler);
      HubServices.connection.on('CiviliteUpdated', HubServices.civiliteUpdatedHandler);
      HubServices.connection.off('CiviliteDeleted', HubServices.civiliteDeletedHandler);
      HubServices.connection.on('CiviliteDeleted', HubServices.civiliteDeletedHandler);
    }
  }

  private static clientCreated: ClientCreated;
  private static clientUpdated: ClientUpdated;
  private static clientDeleted: ClientDeleted;
  private static readonly clientCreatedHandler = (value: ListItem): void => HubServices.clientCreated?.(value);
  private static readonly clientUpdatedHandler = (value: ListItem): void => HubServices.clientUpdated?.(value);
  private static readonly clientDeletedHandler = (value: ListItem): void => HubServices.clientDeleted?.(value);
  public static registerClient (created: ClientCreated, updated: ClientUpdated, deleted: ClientDeleted) {
    HubServices.clientCreated = created;
    HubServices.clientUpdated = updated;
    HubServices.clientDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterClient', storeSession.httpToken);
      HubServices.connection.off('ClientCreated', HubServices.clientCreatedHandler);
      HubServices.connection.on('ClientCreated', HubServices.clientCreatedHandler);
      HubServices.connection.off('ClientUpdated', HubServices.clientUpdatedHandler);
      HubServices.connection.on('ClientUpdated', HubServices.clientUpdatedHandler);
      HubServices.connection.off('ClientDeleted', HubServices.clientDeletedHandler);
      HubServices.connection.on('ClientDeleted', HubServices.clientDeletedHandler);
    }
  }

  private static contactCreated: ContactCreated;
  private static contactUpdated: ContactUpdated;
  private static contactDeleted: ContactDeleted;
  private static readonly contactCreatedHandler = (value: ListItem): void => HubServices.contactCreated?.(value);
  private static readonly contactUpdatedHandler = (value: ListItem): void => HubServices.contactUpdated?.(value);
  private static readonly contactDeletedHandler = (value: ListItem): void => HubServices.contactDeleted?.(value);
  public static registerContact (created: ContactCreated, updated: ContactUpdated, deleted: ContactDeleted) {
    HubServices.contactCreated = created;
    HubServices.contactUpdated = updated;
    HubServices.contactDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContact', storeSession.httpToken);
      HubServices.connection.off('ContactCreated', HubServices.contactCreatedHandler);
      HubServices.connection.on('ContactCreated', HubServices.contactCreatedHandler);
      HubServices.connection.off('ContactUpdated', HubServices.contactUpdatedHandler);
      HubServices.connection.on('ContactUpdated', HubServices.contactUpdatedHandler);
      HubServices.connection.off('ContactDeleted', HubServices.contactDeletedHandler);
      HubServices.connection.on('ContactDeleted', HubServices.contactDeletedHandler);
    }
  }

  private static contratCreated: ContratCreated;
  private static contratUpdated: ContratUpdated;
  private static contratDeleted: ContratDeleted;
  private static readonly contratCreatedHandler = (value: ListItem): void => HubServices.contratCreated?.(value);
  private static readonly contratUpdatedHandler = (value: ListItem): void => HubServices.contratUpdated?.(value);
  private static readonly contratDeletedHandler = (value: ListItem): void => HubServices.contratDeleted?.(value);
  public static registerContrat (created: ContratCreated, updated: ContratUpdated, deleted: ContratDeleted) {
    HubServices.contratCreated = created;
    HubServices.contratUpdated = updated;
    HubServices.contratDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContrat', storeSession.httpToken);
      HubServices.connection.off('ContratCreated', HubServices.contratCreatedHandler);
      HubServices.connection.on('ContratCreated', HubServices.contratCreatedHandler);
      HubServices.connection.off('ContratUpdated', HubServices.contratUpdatedHandler);
      HubServices.connection.on('ContratUpdated', HubServices.contratUpdatedHandler);
      HubServices.connection.off('ContratDeleted', HubServices.contratDeletedHandler);
      HubServices.connection.on('ContratDeleted', HubServices.contratDeletedHandler);
    }
  }

  private static contratTemplateCreated: ContratTemplateCreated;
  private static contratTemplateUpdated: ContratTemplateUpdated;
  private static contratTemplateDeleted: ContratTemplateDeleted;
  private static readonly contratTemplateCreatedHandler = (value: ListItem): void => HubServices.contratTemplateCreated?.(value);
  private static readonly contratTemplateUpdatedHandler = (value: ListItem): void => HubServices.contratTemplateUpdated?.(value);
  private static readonly contratTemplateDeletedHandler = (value: ListItem): void => HubServices.contratTemplateDeleted?.(value);
  public static registerContratTemplate (created: ContratTemplateCreated, updated: ContratTemplateUpdated, deleted: ContratTemplateDeleted) {
    HubServices.contratTemplateCreated = created;
    HubServices.contratTemplateUpdated = updated;
    HubServices.contratTemplateDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContratTemplate', storeSession.httpToken);
      HubServices.connection.off('ContratTemplateCreated', HubServices.contratTemplateCreatedHandler);
      HubServices.connection.on('ContratTemplateCreated', HubServices.contratTemplateCreatedHandler);
      HubServices.connection.off('ContratTemplateUpdated', HubServices.contratTemplateUpdatedHandler);
      HubServices.connection.on('ContratTemplateUpdated', HubServices.contratTemplateUpdatedHandler);
      HubServices.connection.off('ContratTemplateDeleted', HubServices.contratTemplateDeletedHandler);
      HubServices.connection.on('ContratTemplateDeleted', HubServices.contratTemplateDeletedHandler);
    }
  }

  private static creneauCreated: CreneauCreated;
  private static creneauUpdated: CreneauUpdated;
  private static creneauDeleted: CreneauDeleted;
  private static readonly creneauCreatedHandler = (value: ListItem): void => HubServices.creneauCreated?.(value);
  private static readonly creneauUpdatedHandler = (value: ListItem): void => HubServices.creneauUpdated?.(value);
  private static readonly creneauDeletedHandler = (value: ListItem): void => HubServices.creneauDeleted?.(value);
  public static registerCreneau (created: CreneauCreated, updated: CreneauUpdated, deleted: CreneauDeleted) {
    HubServices.creneauCreated = created;
    HubServices.creneauUpdated = updated;
    HubServices.creneauDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCreneau', storeSession.httpToken);
      HubServices.connection.off('CreneauCreated', HubServices.creneauCreatedHandler);
      HubServices.connection.on('CreneauCreated', HubServices.creneauCreatedHandler);
      HubServices.connection.off('CreneauUpdated', HubServices.creneauUpdatedHandler);
      HubServices.connection.on('CreneauUpdated', HubServices.creneauUpdatedHandler);
      HubServices.connection.off('CreneauDeleted', HubServices.creneauDeletedHandler);
      HubServices.connection.on('CreneauDeleted', HubServices.creneauDeletedHandler);
    }
  }

  private static deliveryCreated: DeliveryCreated;
  private static deliveryUpdated: DeliveryUpdated;
  private static deliveryDeleted: DeliveryDeleted;
  private static readonly deliveryCreatedHandler = (value: ListItem): void => HubServices.deliveryCreated?.(value);
  private static readonly deliveryUpdatedHandler = (value: ListItem): void => HubServices.deliveryUpdated?.(value);
  private static readonly deliveryDeletedHandler = (value: ListItem): void => HubServices.deliveryDeleted?.(value);
  public static registerDelivery (created: DeliveryCreated, updated: DeliveryUpdated, deleted: DeliveryDeleted) {
    HubServices.deliveryCreated = created;
    HubServices.deliveryUpdated = updated;
    HubServices.deliveryDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDelivery', storeSession.httpToken);
      HubServices.connection.off('DeliveryCreated', HubServices.deliveryCreatedHandler);
      HubServices.connection.on('DeliveryCreated', HubServices.deliveryCreatedHandler);
      HubServices.connection.off('DeliveryUpdated', HubServices.deliveryUpdatedHandler);
      HubServices.connection.on('DeliveryUpdated', HubServices.deliveryUpdatedHandler);
      HubServices.connection.off('DeliveryDeleted', HubServices.deliveryDeletedHandler);
      HubServices.connection.on('DeliveryDeleted', HubServices.deliveryDeletedHandler);
    }
  }

  private static documentCreated: DocumentCreated;
  private static documentUpdated: DocumentUpdated;
  private static documentDeleted: DocumentDeleted;
  private static readonly documentCreatedHandler = (value: ListItem): void => HubServices.documentCreated?.(value);
  private static readonly documentUpdatedHandler = (value: ListItem): void => HubServices.documentUpdated?.(value);
  private static readonly documentDeletedHandler = (value: ListItem): void => HubServices.documentDeleted?.(value);
  public static registerDocument (created: DocumentCreated, updated: DocumentUpdated, deleted: DocumentDeleted) {
    HubServices.documentCreated = created;
    HubServices.documentUpdated = updated;
    HubServices.documentDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDocument', storeSession.httpToken);
      HubServices.connection.off('DocumentCreated', HubServices.documentCreatedHandler);
      HubServices.connection.on('DocumentCreated', HubServices.documentCreatedHandler);
      HubServices.connection.off('DocumentUpdated', HubServices.documentUpdatedHandler);
      HubServices.connection.on('DocumentUpdated', HubServices.documentUpdatedHandler);
      HubServices.connection.off('DocumentDeleted', HubServices.documentDeletedHandler);
      HubServices.connection.on('DocumentDeleted', HubServices.documentDeletedHandler);
    }
  }

  private static documentTypeCreated: DocumentTypeCreated;
  private static documentTypeUpdated: DocumentTypeUpdated;
  private static documentTypeDeleted: DocumentTypeDeleted;
  private static readonly documentTypeCreatedHandler = (value: ListItem): void => HubServices.documentTypeCreated?.(value);
  private static readonly documentTypeUpdatedHandler = (value: ListItem): void => HubServices.documentTypeUpdated?.(value);
  private static readonly documentTypeDeletedHandler = (value: ListItem): void => HubServices.documentTypeDeleted?.(value);
  public static registerDocumentType (created: DocumentTypeCreated, updated: DocumentTypeUpdated, deleted: DocumentTypeDeleted) {
    HubServices.documentTypeCreated = created;
    HubServices.documentTypeUpdated = updated;
    HubServices.documentTypeDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDocumentType', storeSession.httpToken);
      HubServices.connection.off('DocumentTypeCreated', HubServices.documentTypeCreatedHandler);
      HubServices.connection.on('DocumentTypeCreated', HubServices.documentTypeCreatedHandler);
      HubServices.connection.off('DocumentTypeUpdated', HubServices.documentTypeUpdatedHandler);
      HubServices.connection.on('DocumentTypeUpdated', HubServices.documentTypeUpdatedHandler);
      HubServices.connection.off('DocumentTypeDeleted', HubServices.documentTypeDeletedHandler);
      HubServices.connection.on('DocumentTypeDeleted', HubServices.documentTypeDeletedHandler);
    }
  }

  private static etablissementCreated: EtablissementCreated;
  private static etablissementUpdated: EtablissementUpdated;
  private static etablissementDeleted: EtablissementDeleted;
  private static readonly etablissementCreatedHandler = (value: ListItem): void => HubServices.etablissementCreated?.(value);
  private static readonly etablissementUpdatedHandler = (value: ListItem): void => HubServices.etablissementUpdated?.(value);
  private static readonly etablissementDeletedHandler = (value: ListItem): void => HubServices.etablissementDeleted?.(value);
  public static registerEtablissement (created: EtablissementCreated, updated: EtablissementUpdated, deleted: EtablissementDeleted) {
    HubServices.etablissementCreated = created;
    HubServices.etablissementUpdated = updated;
    HubServices.etablissementDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterEtablissement', storeSession.httpToken);
      HubServices.connection.off('EtablissementCreated', HubServices.etablissementCreatedHandler);
      HubServices.connection.on('EtablissementCreated', HubServices.etablissementCreatedHandler);
      HubServices.connection.off('EtablissementUpdated', HubServices.etablissementUpdatedHandler);
      HubServices.connection.on('EtablissementUpdated', HubServices.etablissementUpdatedHandler);
      HubServices.connection.off('EtablissementDeleted', HubServices.etablissementDeletedHandler);
      HubServices.connection.on('EtablissementDeleted', HubServices.etablissementDeletedHandler);
    }
  }

  private static fractionDsnCreated: FractionDsnCreated;
  private static fractionDsnUpdated: FractionDsnUpdated;
  private static fractionDsnDeleted: FractionDsnDeleted;
  private static readonly fractionDsnCreatedHandler = (value: ListItem): void => HubServices.fractionDsnCreated?.(value);
  private static readonly fractionDsnUpdatedHandler = (value: ListItem): void => HubServices.fractionDsnUpdated?.(value);
  private static readonly fractionDsnDeletedHandler = (value: ListItem): void => HubServices.fractionDsnDeleted?.(value);
  public static registerFractionDsn (created: FractionDsnCreated, updated: FractionDsnUpdated, deleted: FractionDsnDeleted) {
    HubServices.fractionDsnCreated = created;
    HubServices.fractionDsnUpdated = updated;
    HubServices.fractionDsnDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterFractionDsn', storeSession.httpToken);
      HubServices.connection.off('FractionDsnCreated', HubServices.fractionDsnCreatedHandler);
      HubServices.connection.on('FractionDsnCreated', HubServices.fractionDsnCreatedHandler);
      HubServices.connection.off('FractionDsnUpdated', HubServices.fractionDsnUpdatedHandler);
      HubServices.connection.on('FractionDsnUpdated', HubServices.fractionDsnUpdatedHandler);
      HubServices.connection.off('FractionDsnDeleted', HubServices.fractionDsnDeletedHandler);
      HubServices.connection.on('FractionDsnDeleted', HubServices.fractionDsnDeletedHandler);
    }
  }

  private static lieuCreated: LieuCreated;
  private static lieuUpdated: LieuUpdated;
  private static lieuDeleted: LieuDeleted;
  private static readonly lieuCreatedHandler = (value: ListItem): void => HubServices.lieuCreated?.(value);
  private static readonly lieuUpdatedHandler = (value: ListItem): void => HubServices.lieuUpdated?.(value);
  private static readonly lieuDeletedHandler = (value: ListItem): void => HubServices.lieuDeleted?.(value);
  public static registerLieu (created: LieuCreated, updated: LieuUpdated, deleted: LieuDeleted) {
    HubServices.lieuCreated = created;
    HubServices.lieuUpdated = updated;
    HubServices.lieuDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterLieu', storeSession.httpToken);
      HubServices.connection.off('LieuCreated', HubServices.lieuCreatedHandler);
      HubServices.connection.on('LieuCreated', HubServices.lieuCreatedHandler);
      HubServices.connection.off('LieuUpdated', HubServices.lieuUpdatedHandler);
      HubServices.connection.on('LieuUpdated', HubServices.lieuUpdatedHandler);
      HubServices.connection.off('LieuDeleted', HubServices.lieuDeletedHandler);
      HubServices.connection.on('LieuDeleted', HubServices.lieuDeletedHandler);
    }
  }

  private static mailCreated: MailCreated;
  private static mailUpdated: MailUpdated;
  private static mailDeleted: MailDeleted;
  private static readonly mailCreatedHandler = (value: ListItem): void => HubServices.mailCreated?.(value);
  private static readonly mailUpdatedHandler = (value: ListItem): void => HubServices.mailUpdated?.(value);
  private static readonly mailDeletedHandler = (value: ListItem): void => HubServices.mailDeleted?.(value);
  public static registerMail (created: MailCreated, updated: MailUpdated, deleted: MailDeleted) {
    HubServices.mailCreated = created;
    HubServices.mailUpdated = updated;
    HubServices.mailDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMail', storeSession.httpToken);
      HubServices.connection.off('MailCreated', HubServices.mailCreatedHandler);
      HubServices.connection.on('MailCreated', HubServices.mailCreatedHandler);
      HubServices.connection.off('MailUpdated', HubServices.mailUpdatedHandler);
      HubServices.connection.on('MailUpdated', HubServices.mailUpdatedHandler);
      HubServices.connection.off('MailDeleted', HubServices.mailDeletedHandler);
      HubServices.connection.on('MailDeleted', HubServices.mailDeletedHandler);
    }
  }

  private static manualBillingDocumentCreated: ManualBillingDocumentCreated;
  private static manualBillingDocumentUpdated: ManualBillingDocumentUpdated;
  private static manualBillingDocumentDeleted: ManualBillingDocumentDeleted;
  private static readonly manualBillingDocumentCreatedHandler = (value: ListItem): void => HubServices.manualBillingDocumentCreated?.(value);
  private static readonly manualBillingDocumentUpdatedHandler = (value: ListItem): void => HubServices.manualBillingDocumentUpdated?.(value);
  private static readonly manualBillingDocumentDeletedHandler = (value: ListItem): void => HubServices.manualBillingDocumentDeleted?.(value);
  public static registerManualBillingDocument (created: ManualBillingDocumentCreated, updated: ManualBillingDocumentUpdated, deleted: ManualBillingDocumentDeleted) {
    HubServices.manualBillingDocumentCreated = created;
    HubServices.manualBillingDocumentUpdated = updated;
    HubServices.manualBillingDocumentDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterManualBillingDocument', storeSession.httpToken);
      HubServices.connection.off('ManualBillingDocumentCreated', HubServices.manualBillingDocumentCreatedHandler);
      HubServices.connection.on('ManualBillingDocumentCreated', HubServices.manualBillingDocumentCreatedHandler);
      HubServices.connection.off('ManualBillingDocumentUpdated', HubServices.manualBillingDocumentUpdatedHandler);
      HubServices.connection.on('ManualBillingDocumentUpdated', HubServices.manualBillingDocumentUpdatedHandler);
      HubServices.connection.off('ManualBillingDocumentDeleted', HubServices.manualBillingDocumentDeletedHandler);
      HubServices.connection.on('ManualBillingDocumentDeleted', HubServices.manualBillingDocumentDeletedHandler);
    }
  }

  private static metaAttribCreated: MetaAttribCreated;
  private static metaAttribUpdated: MetaAttribUpdated;
  private static metaAttribDeleted: MetaAttribDeleted;
  private static readonly metaAttribCreatedHandler = (value: ListItem): void => HubServices.metaAttribCreated?.(value);
  private static readonly metaAttribUpdatedHandler = (value: ListItem): void => HubServices.metaAttribUpdated?.(value);
  private static readonly metaAttribDeletedHandler = (value: ListItem): void => HubServices.metaAttribDeleted?.(value);
  public static registerMetaAttrib (created: MetaAttribCreated, updated: MetaAttribUpdated, deleted: MetaAttribDeleted) {
    HubServices.metaAttribCreated = created;
    HubServices.metaAttribUpdated = updated;
    HubServices.metaAttribDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMetaAttrib', storeSession.httpToken);
      HubServices.connection.off('MetaAttribCreated', HubServices.metaAttribCreatedHandler);
      HubServices.connection.on('MetaAttribCreated', HubServices.metaAttribCreatedHandler);
      HubServices.connection.off('MetaAttribUpdated', HubServices.metaAttribUpdatedHandler);
      HubServices.connection.on('MetaAttribUpdated', HubServices.metaAttribUpdatedHandler);
      HubServices.connection.off('MetaAttribDeleted', HubServices.metaAttribDeletedHandler);
      HubServices.connection.on('MetaAttribDeleted', HubServices.metaAttribDeletedHandler);
    }
  }

  private static notifCreated: NotifCreated;
  private static notifUpdated: NotifUpdated;
  private static notifDeleted: NotifDeleted;
  private static readonly notifCreatedHandler = (value: ListItem): void => HubServices.notifCreated?.(value);
  private static readonly notifUpdatedHandler = (value: ListItem): void => HubServices.notifUpdated?.(value);
  private static readonly notifDeletedHandler = (value: ListItem): void => HubServices.notifDeleted?.(value);
  public static registerNotif (created: NotifCreated, updated: NotifUpdated, deleted: NotifDeleted) {
    HubServices.notifCreated = created;
    HubServices.notifUpdated = updated;
    HubServices.notifDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNotif', storeSession.httpToken);
      HubServices.connection.off('NotifCreated', HubServices.notifCreatedHandler);
      HubServices.connection.on('NotifCreated', HubServices.notifCreatedHandler);
      HubServices.connection.off('NotifUpdated', HubServices.notifUpdatedHandler);
      HubServices.connection.on('NotifUpdated', HubServices.notifUpdatedHandler);
      HubServices.connection.off('NotifDeleted', HubServices.notifDeletedHandler);
      HubServices.connection.on('NotifDeleted', HubServices.notifDeletedHandler);
    }
  }

  private static numeroCreated: NumeroCreated;
  private static numeroUpdated: NumeroUpdated;
  private static numeroDeleted: NumeroDeleted;
  private static readonly numeroCreatedHandler = (value: ListItem): void => HubServices.numeroCreated?.(value);
  private static readonly numeroUpdatedHandler = (value: ListItem): void => HubServices.numeroUpdated?.(value);
  private static readonly numeroDeletedHandler = (value: ListItem): void => HubServices.numeroDeleted?.(value);
  public static registerNumero (created: NumeroCreated, updated: NumeroUpdated, deleted: NumeroDeleted) {
    HubServices.numeroCreated = created;
    HubServices.numeroUpdated = updated;
    HubServices.numeroDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNumero', storeSession.httpToken);
      HubServices.connection.off('NumeroCreated', HubServices.numeroCreatedHandler);
      HubServices.connection.on('NumeroCreated', HubServices.numeroCreatedHandler);
      HubServices.connection.off('NumeroUpdated', HubServices.numeroUpdatedHandler);
      HubServices.connection.on('NumeroUpdated', HubServices.numeroUpdatedHandler);
      HubServices.connection.off('NumeroDeleted', HubServices.numeroDeletedHandler);
      HubServices.connection.on('NumeroDeleted', HubServices.numeroDeletedHandler);
    }
  }

  private static numeroObjetCreated: NumeroObjetCreated;
  private static numeroObjetUpdated: NumeroObjetUpdated;
  private static numeroObjetDeleted: NumeroObjetDeleted;
  private static readonly numeroObjetCreatedHandler = (value: ListItem): void => HubServices.numeroObjetCreated?.(value);
  private static readonly numeroObjetUpdatedHandler = (value: ListItem): void => HubServices.numeroObjetUpdated?.(value);
  private static readonly numeroObjetDeletedHandler = (value: ListItem): void => HubServices.numeroObjetDeleted?.(value);
  public static registerNumeroObjet (created: NumeroObjetCreated, updated: NumeroObjetUpdated, deleted: NumeroObjetDeleted) {
    HubServices.numeroObjetCreated = created;
    HubServices.numeroObjetUpdated = updated;
    HubServices.numeroObjetDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNumeroObjet', storeSession.httpToken);
      HubServices.connection.off('NumeroObjetCreated', HubServices.numeroObjetCreatedHandler);
      HubServices.connection.on('NumeroObjetCreated', HubServices.numeroObjetCreatedHandler);
      HubServices.connection.off('NumeroObjetUpdated', HubServices.numeroObjetUpdatedHandler);
      HubServices.connection.on('NumeroObjetUpdated', HubServices.numeroObjetUpdatedHandler);
      HubServices.connection.off('NumeroObjetDeleted', HubServices.numeroObjetDeletedHandler);
      HubServices.connection.on('NumeroObjetDeleted', HubServices.numeroObjetDeletedHandler);
    }
  }

  private static objetMetierCreated: ObjetMetierCreated;
  private static objetMetierUpdated: ObjetMetierUpdated;
  private static objetMetierDeleted: ObjetMetierDeleted;
  private static readonly objetMetierCreatedHandler = (value: ListItem): void => HubServices.objetMetierCreated?.(value);
  private static readonly objetMetierUpdatedHandler = (value: ListItem): void => HubServices.objetMetierUpdated?.(value);
  private static readonly objetMetierDeletedHandler = (value: ListItem): void => HubServices.objetMetierDeleted?.(value);
  public static registerObjetMetier (created: ObjetMetierCreated, updated: ObjetMetierUpdated, deleted: ObjetMetierDeleted) {
    HubServices.objetMetierCreated = created;
    HubServices.objetMetierUpdated = updated;
    HubServices.objetMetierDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterObjetMetier', storeSession.httpToken);
      HubServices.connection.off('ObjetMetierCreated', HubServices.objetMetierCreatedHandler);
      HubServices.connection.on('ObjetMetierCreated', HubServices.objetMetierCreatedHandler);
      HubServices.connection.off('ObjetMetierUpdated', HubServices.objetMetierUpdatedHandler);
      HubServices.connection.on('ObjetMetierUpdated', HubServices.objetMetierUpdatedHandler);
      HubServices.connection.off('ObjetMetierDeleted', HubServices.objetMetierDeletedHandler);
      HubServices.connection.on('ObjetMetierDeleted', HubServices.objetMetierDeletedHandler);
    }
  }

  private static paieCreated: PaieCreated;
  private static paieUpdated: PaieUpdated;
  private static paieDeleted: PaieDeleted;
  private static readonly paieCreatedHandler = (value: ListItem): void => HubServices.paieCreated?.(value);
  private static readonly paieUpdatedHandler = (value: ListItem): void => HubServices.paieUpdated?.(value);
  private static readonly paieDeletedHandler = (value: ListItem): void => HubServices.paieDeleted?.(value);
  public static registerPaie (created: PaieCreated, updated: PaieUpdated, deleted: PaieDeleted) {
    HubServices.paieCreated = created;
    HubServices.paieUpdated = updated;
    HubServices.paieDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPaie', storeSession.httpToken);
      HubServices.connection.off('PaieCreated', HubServices.paieCreatedHandler);
      HubServices.connection.on('PaieCreated', HubServices.paieCreatedHandler);
      HubServices.connection.off('PaieUpdated', HubServices.paieUpdatedHandler);
      HubServices.connection.on('PaieUpdated', HubServices.paieUpdatedHandler);
      HubServices.connection.off('PaieDeleted', HubServices.paieDeletedHandler);
      HubServices.connection.on('PaieDeleted', HubServices.paieDeletedHandler);
    }
  }

  private static paymentMeansCreated: PaymentMeansCreated;
  private static paymentMeansUpdated: PaymentMeansUpdated;
  private static paymentMeansDeleted: PaymentMeansDeleted;
  private static readonly paymentMeansCreatedHandler = (value: ListItem): void => HubServices.paymentMeansCreated?.(value);
  private static readonly paymentMeansUpdatedHandler = (value: ListItem): void => HubServices.paymentMeansUpdated?.(value);
  private static readonly paymentMeansDeletedHandler = (value: ListItem): void => HubServices.paymentMeansDeleted?.(value);
  public static registerPaymentMeans (created: PaymentMeansCreated, updated: PaymentMeansUpdated, deleted: PaymentMeansDeleted) {
    HubServices.paymentMeansCreated = created;
    HubServices.paymentMeansUpdated = updated;
    HubServices.paymentMeansDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPaymentMeans', storeSession.httpToken);
      HubServices.connection.off('PaymentMeansCreated', HubServices.paymentMeansCreatedHandler);
      HubServices.connection.on('PaymentMeansCreated', HubServices.paymentMeansCreatedHandler);
      HubServices.connection.off('PaymentMeansUpdated', HubServices.paymentMeansUpdatedHandler);
      HubServices.connection.on('PaymentMeansUpdated', HubServices.paymentMeansUpdatedHandler);
      HubServices.connection.off('PaymentMeansDeleted', HubServices.paymentMeansDeletedHandler);
      HubServices.connection.on('PaymentMeansDeleted', HubServices.paymentMeansDeletedHandler);
    }
  }

  private static plageCreneauCreated: PlageCreneauCreated;
  private static plageCreneauUpdated: PlageCreneauUpdated;
  private static plageCreneauDeleted: PlageCreneauDeleted;
  private static readonly plageCreneauCreatedHandler = (value: ListItem): void => HubServices.plageCreneauCreated?.(value);
  private static readonly plageCreneauUpdatedHandler = (value: ListItem): void => HubServices.plageCreneauUpdated?.(value);
  private static readonly plageCreneauDeletedHandler = (value: ListItem): void => HubServices.plageCreneauDeleted?.(value);
  public static registerPlageCreneau (created: PlageCreneauCreated, updated: PlageCreneauUpdated, deleted: PlageCreneauDeleted) {
    HubServices.plageCreneauCreated = created;
    HubServices.plageCreneauUpdated = updated;
    HubServices.plageCreneauDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPlageCreneau', storeSession.httpToken);
      HubServices.connection.off('PlageCreneauCreated', HubServices.plageCreneauCreatedHandler);
      HubServices.connection.on('PlageCreneauCreated', HubServices.plageCreneauCreatedHandler);
      HubServices.connection.off('PlageCreneauUpdated', HubServices.plageCreneauUpdatedHandler);
      HubServices.connection.on('PlageCreneauUpdated', HubServices.plageCreneauUpdatedHandler);
      HubServices.connection.off('PlageCreneauDeleted', HubServices.plageCreneauDeletedHandler);
      HubServices.connection.on('PlageCreneauDeleted', HubServices.plageCreneauDeletedHandler);
    }
  }

  private static projetCreated: ProjetCreated;
  private static projetUpdated: ProjetUpdated;
  private static projetDeleted: ProjetDeleted;
  private static readonly projetCreatedHandler = (value: ListItem): void => HubServices.projetCreated?.(value);
  private static readonly projetUpdatedHandler = (value: ListItem): void => HubServices.projetUpdated?.(value);
  private static readonly projetDeletedHandler = (value: ListItem): void => HubServices.projetDeleted?.(value);
  public static registerProjet (created: ProjetCreated, updated: ProjetUpdated, deleted: ProjetDeleted) {
    HubServices.projetCreated = created;
    HubServices.projetUpdated = updated;
    HubServices.projetDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterProjet', storeSession.httpToken);
      HubServices.connection.off('ProjetCreated', HubServices.projetCreatedHandler);
      HubServices.connection.on('ProjetCreated', HubServices.projetCreatedHandler);
      HubServices.connection.off('ProjetUpdated', HubServices.projetUpdatedHandler);
      HubServices.connection.on('ProjetUpdated', HubServices.projetUpdatedHandler);
      HubServices.connection.off('ProjetDeleted', HubServices.projetDeletedHandler);
      HubServices.connection.on('ProjetDeleted', HubServices.projetDeletedHandler);
    }
  }

  private static qualiteCreated: QualiteCreated;
  private static qualiteUpdated: QualiteUpdated;
  private static qualiteDeleted: QualiteDeleted;
  private static readonly qualiteCreatedHandler = (value: ListItem): void => HubServices.qualiteCreated?.(value);
  private static readonly qualiteUpdatedHandler = (value: ListItem): void => HubServices.qualiteUpdated?.(value);
  private static readonly qualiteDeletedHandler = (value: ListItem): void => HubServices.qualiteDeleted?.(value);
  public static registerQualite (created: QualiteCreated, updated: QualiteUpdated, deleted: QualiteDeleted) {
    HubServices.qualiteCreated = created;
    HubServices.qualiteUpdated = updated;
    HubServices.qualiteDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterQualite', storeSession.httpToken);
      HubServices.connection.off('QualiteCreated', HubServices.qualiteCreatedHandler);
      HubServices.connection.on('QualiteCreated', HubServices.qualiteCreatedHandler);
      HubServices.connection.off('QualiteUpdated', HubServices.qualiteUpdatedHandler);
      HubServices.connection.on('QualiteUpdated', HubServices.qualiteUpdatedHandler);
      HubServices.connection.off('QualiteDeleted', HubServices.qualiteDeletedHandler);
      HubServices.connection.on('QualiteDeleted', HubServices.qualiteDeletedHandler);
    }
  }

  private static ribCreated: RibCreated;
  private static ribUpdated: RibUpdated;
  private static ribDeleted: RibDeleted;
  private static readonly ribCreatedHandler = (value: ListItem): void => HubServices.ribCreated?.(value);
  private static readonly ribUpdatedHandler = (value: ListItem): void => HubServices.ribUpdated?.(value);
  private static readonly ribDeletedHandler = (value: ListItem): void => HubServices.ribDeleted?.(value);
  public static registerRib (created: RibCreated, updated: RibUpdated, deleted: RibDeleted) {
    HubServices.ribCreated = created;
    HubServices.ribUpdated = updated;
    HubServices.ribDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRib', storeSession.httpToken);
      HubServices.connection.off('RibCreated', HubServices.ribCreatedHandler);
      HubServices.connection.on('RibCreated', HubServices.ribCreatedHandler);
      HubServices.connection.off('RibUpdated', HubServices.ribUpdatedHandler);
      HubServices.connection.on('RibUpdated', HubServices.ribUpdatedHandler);
      HubServices.connection.off('RibDeleted', HubServices.ribDeletedHandler);
      HubServices.connection.on('RibDeleted', HubServices.ribDeletedHandler);
    }
  }

  private static rubriqueCreated: RubriqueCreated;
  private static rubriqueUpdated: RubriqueUpdated;
  private static rubriqueDeleted: RubriqueDeleted;
  private static readonly rubriqueCreatedHandler = (value: ListItem): void => HubServices.rubriqueCreated?.(value);
  private static readonly rubriqueUpdatedHandler = (value: ListItem): void => HubServices.rubriqueUpdated?.(value);
  private static readonly rubriqueDeletedHandler = (value: ListItem): void => HubServices.rubriqueDeleted?.(value);
  public static registerRubrique (created: RubriqueCreated, updated: RubriqueUpdated, deleted: RubriqueDeleted) {
    HubServices.rubriqueCreated = created;
    HubServices.rubriqueUpdated = updated;
    HubServices.rubriqueDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRubrique', storeSession.httpToken);
      HubServices.connection.off('RubriqueCreated', HubServices.rubriqueCreatedHandler);
      HubServices.connection.on('RubriqueCreated', HubServices.rubriqueCreatedHandler);
      HubServices.connection.off('RubriqueUpdated', HubServices.rubriqueUpdatedHandler);
      HubServices.connection.on('RubriqueUpdated', HubServices.rubriqueUpdatedHandler);
      HubServices.connection.off('RubriqueDeleted', HubServices.rubriqueDeletedHandler);
      HubServices.connection.on('RubriqueDeleted', HubServices.rubriqueDeletedHandler);
    }
  }

  private static salarieCreated: SalarieCreated;
  private static salarieUpdated: SalarieUpdated;
  private static salarieDeleted: SalarieDeleted;
  private static readonly salarieCreatedHandler = (value: ListItem): void => HubServices.salarieCreated?.(value);
  private static readonly salarieUpdatedHandler = (value: ListItem): void => HubServices.salarieUpdated?.(value);
  private static readonly salarieDeletedHandler = (value: ListItem): void => HubServices.salarieDeleted?.(value);
  public static registerSalarie (created: SalarieCreated, updated: SalarieUpdated, deleted: SalarieDeleted) {
    HubServices.salarieCreated = created;
    HubServices.salarieUpdated = updated;
    HubServices.salarieDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSalarie', storeSession.httpToken);
      HubServices.connection.off('SalarieCreated', HubServices.salarieCreatedHandler);
      HubServices.connection.on('SalarieCreated', HubServices.salarieCreatedHandler);
      HubServices.connection.off('SalarieUpdated', HubServices.salarieUpdatedHandler);
      HubServices.connection.on('SalarieUpdated', HubServices.salarieUpdatedHandler);
      HubServices.connection.off('SalarieDeleted', HubServices.salarieDeletedHandler);
      HubServices.connection.on('SalarieDeleted', HubServices.salarieDeletedHandler);
    }
  }

  private static subscriptionCreated: SubscriptionCreated;
  private static subscriptionUpdated: SubscriptionUpdated;
  private static subscriptionDeleted: SubscriptionDeleted;
  private static readonly subscriptionCreatedHandler = (value: ListItem): void => HubServices.subscriptionCreated?.(value);
  private static readonly subscriptionUpdatedHandler = (value: ListItem): void => HubServices.subscriptionUpdated?.(value);
  private static readonly subscriptionDeletedHandler = (value: ListItem): void => HubServices.subscriptionDeleted?.(value);
  public static registerSubscription (created: SubscriptionCreated, updated: SubscriptionUpdated, deleted: SubscriptionDeleted) {
    HubServices.subscriptionCreated = created;
    HubServices.subscriptionUpdated = updated;
    HubServices.subscriptionDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSubscription', storeSession.httpToken);
      HubServices.connection.off('SubscriptionCreated', HubServices.subscriptionCreatedHandler);
      HubServices.connection.on('SubscriptionCreated', HubServices.subscriptionCreatedHandler);
      HubServices.connection.off('SubscriptionUpdated', HubServices.subscriptionUpdatedHandler);
      HubServices.connection.on('SubscriptionUpdated', HubServices.subscriptionUpdatedHandler);
      HubServices.connection.off('SubscriptionDeleted', HubServices.subscriptionDeletedHandler);
      HubServices.connection.on('SubscriptionDeleted', HubServices.subscriptionDeletedHandler);
    }
  }

  private static subscriptionTypeCreated: SubscriptionTypeCreated;
  private static subscriptionTypeUpdated: SubscriptionTypeUpdated;
  private static subscriptionTypeDeleted: SubscriptionTypeDeleted;
  private static readonly subscriptionTypeCreatedHandler = (value: ListItem): void => HubServices.subscriptionTypeCreated?.(value);
  private static readonly subscriptionTypeUpdatedHandler = (value: ListItem): void => HubServices.subscriptionTypeUpdated?.(value);
  private static readonly subscriptionTypeDeletedHandler = (value: ListItem): void => HubServices.subscriptionTypeDeleted?.(value);
  public static registerSubscriptionType (created: SubscriptionTypeCreated, updated: SubscriptionTypeUpdated, deleted: SubscriptionTypeDeleted) {
    HubServices.subscriptionTypeCreated = created;
    HubServices.subscriptionTypeUpdated = updated;
    HubServices.subscriptionTypeDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSubscriptionType', storeSession.httpToken);
      HubServices.connection.off('SubscriptionTypeCreated', HubServices.subscriptionTypeCreatedHandler);
      HubServices.connection.on('SubscriptionTypeCreated', HubServices.subscriptionTypeCreatedHandler);
      HubServices.connection.off('SubscriptionTypeUpdated', HubServices.subscriptionTypeUpdatedHandler);
      HubServices.connection.on('SubscriptionTypeUpdated', HubServices.subscriptionTypeUpdatedHandler);
      HubServices.connection.off('SubscriptionTypeDeleted', HubServices.subscriptionTypeDeletedHandler);
      HubServices.connection.on('SubscriptionTypeDeleted', HubServices.subscriptionTypeDeletedHandler);
    }
  }

  private static supportCreated: SupportCreated;
  private static supportUpdated: SupportUpdated;
  private static supportDeleted: SupportDeleted;
  private static readonly supportCreatedHandler = (value: ListItem): void => HubServices.supportCreated?.(value);
  private static readonly supportUpdatedHandler = (value: ListItem): void => HubServices.supportUpdated?.(value);
  private static readonly supportDeletedHandler = (value: ListItem): void => HubServices.supportDeleted?.(value);
  public static registerSupport (created: SupportCreated, updated: SupportUpdated, deleted: SupportDeleted) {
    HubServices.supportCreated = created;
    HubServices.supportUpdated = updated;
    HubServices.supportDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSupport', storeSession.httpToken);
      HubServices.connection.off('SupportCreated', HubServices.supportCreatedHandler);
      HubServices.connection.on('SupportCreated', HubServices.supportCreatedHandler);
      HubServices.connection.off('SupportUpdated', HubServices.supportUpdatedHandler);
      HubServices.connection.on('SupportUpdated', HubServices.supportUpdatedHandler);
      HubServices.connection.off('SupportDeleted', HubServices.supportDeletedHandler);
      HubServices.connection.on('SupportDeleted', HubServices.supportDeletedHandler);
    }
  }

  private static transactionCreated: TransactionCreated;
  private static transactionUpdated: TransactionUpdated;
  private static transactionDeleted: TransactionDeleted;
  private static readonly transactionCreatedHandler = (value: ListItem): void => HubServices.transactionCreated?.(value);
  private static readonly transactionUpdatedHandler = (value: ListItem): void => HubServices.transactionUpdated?.(value);
  private static readonly transactionDeletedHandler = (value: ListItem): void => HubServices.transactionDeleted?.(value);
  public static registerTransaction (created: TransactionCreated, updated: TransactionUpdated, deleted: TransactionDeleted) {
    HubServices.transactionCreated = created;
    HubServices.transactionUpdated = updated;
    HubServices.transactionDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterTransaction', storeSession.httpToken);
      HubServices.connection.off('TransactionCreated', HubServices.transactionCreatedHandler);
      HubServices.connection.on('TransactionCreated', HubServices.transactionCreatedHandler);
      HubServices.connection.off('TransactionUpdated', HubServices.transactionUpdatedHandler);
      HubServices.connection.on('TransactionUpdated', HubServices.transactionUpdatedHandler);
      HubServices.connection.off('TransactionDeleted', HubServices.transactionDeletedHandler);
      HubServices.connection.on('TransactionDeleted', HubServices.transactionDeletedHandler);
    }
  }

  private static userCreated: UserCreated;
  private static userUpdated: UserUpdated;
  private static userDeleted: UserDeleted;
  private static readonly userCreatedHandler = (value: ListItem): void => HubServices.userCreated?.(value);
  private static readonly userUpdatedHandler = (value: ListItem): void => HubServices.userUpdated?.(value);
  private static readonly userDeletedHandler = (value: ListItem): void => HubServices.userDeleted?.(value);
  public static registerUser (created: UserCreated, updated: UserUpdated, deleted: UserDeleted) {
    HubServices.userCreated = created;
    HubServices.userUpdated = updated;
    HubServices.userDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterUser', storeSession.httpToken);
      HubServices.connection.off('UserCreated', HubServices.userCreatedHandler);
      HubServices.connection.on('UserCreated', HubServices.userCreatedHandler);
      HubServices.connection.off('UserUpdated', HubServices.userUpdatedHandler);
      HubServices.connection.on('UserUpdated', HubServices.userUpdatedHandler);
      HubServices.connection.off('UserDeleted', HubServices.userDeletedHandler);
      HubServices.connection.on('UserDeleted', HubServices.userDeletedHandler);
    }
  }

  private static wizardItemCreated: WizardItemCreated;
  private static wizardItemUpdated: WizardItemUpdated;
  private static wizardItemDeleted: WizardItemDeleted;
  private static readonly wizardItemCreatedHandler = (value: ListItem): void => HubServices.wizardItemCreated?.(value);
  private static readonly wizardItemUpdatedHandler = (value: ListItem): void => HubServices.wizardItemUpdated?.(value);
  private static readonly wizardItemDeletedHandler = (value: ListItem): void => HubServices.wizardItemDeleted?.(value);
  public static registerWizardItem (created: WizardItemCreated, updated: WizardItemUpdated, deleted: WizardItemDeleted) {
    HubServices.wizardItemCreated = created;
    HubServices.wizardItemUpdated = updated;
    HubServices.wizardItemDeleted = deleted;
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterWizardItem', storeSession.httpToken);
      HubServices.connection.off('WizardItemCreated', HubServices.wizardItemCreatedHandler);
      HubServices.connection.on('WizardItemCreated', HubServices.wizardItemCreatedHandler);
      HubServices.connection.off('WizardItemUpdated', HubServices.wizardItemUpdatedHandler);
      HubServices.connection.on('WizardItemUpdated', HubServices.wizardItemUpdatedHandler);
      HubServices.connection.off('WizardItemDeleted', HubServices.wizardItemDeletedHandler);
      HubServices.connection.on('WizardItemDeleted', HubServices.wizardItemDeletedHandler);
    }
  }
}
